import { AbstractJavascriptFunctionCallVO } from "./vo/AbstractJavascriptFunctionCallVO";
import { JavascriptCallDefaultVO } from "./vo/JavascriptCallDefaultVO";

export class JavascriptCallDefaultFactory {
    public createVO(functionName: string = ""): AbstractJavascriptFunctionCallVO {
        var vo: AbstractJavascriptFunctionCallVO;

        // Function name unknown. Create a default js function call VO and try calling the given function name though.
        if (functionName && functionName != "") {
            vo = new JavascriptCallDefaultVO(functionName);
        }

        return vo;
    }
}
